/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-empty-object-type */
/* eslint-disable @typescript-eslint/no-unused-vars */

import { RowData, Table, TableFeature } from '@tanstack/react-table'

export type DataTableCustomEventParams<T = string, P = any> = {
  eventName: T
  // You have to define the type of eventParams on the other side (because you send anything from the column components)

  eventParams: P
}

export type DataTableCustomEvent<T, P> = (
  params: DataTableCustomEventParams<T, P>,
) => void

export interface DataTableCustomEventOptions {
  onCustomEvent?: DataTableCustomEvent<any, any>
  onRefreshData?: () => void
}

export interface DataTableCustomEventInstance {
  emitCustomEvent: (params: DataTableCustomEventParams) => void
  emitRefreshData: () => void
}

declare module '@tanstack/react-table' {
  interface TableOptionsResolved<TData extends RowData>
    extends DataTableCustomEventOptions {}

  interface Table<TData extends RowData> extends DataTableCustomEventInstance {}

  interface ColumnMeta<TData extends RowData, TValue> {
    cellClassName?: string
    rowClassName?: string

    [key: string]: any // Allows additional custom properties
  }
}

export const DataTableCustomEventFeature: TableFeature = {
  createTable: <TData extends RowData>(table: Table<TData>): void => {
    table.emitCustomEvent = (params) => {
      return table.options.onCustomEvent?.(params)
    }
    table.emitRefreshData = () => {
      return table.options.onRefreshData?.()
    }
  },
}
